import hbscan from "../../api/hbscan";
import { IRoute, IRouteCreate, IRouteUpdate } from "../../models/route";
import Auth from "../auth/AuthService";

class RouteService {
    PostRoute = async (route: IRouteCreate) => {
        const URL = `/api/hbscan/Route/PostRouteLocal`;
        return (
            await hbscan.post<number>(URL, JSON.stringify(route), {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };

    DeleteRoute = async (routeId: number) => {
        const URL = `/api/hbscan/Route/DeleteRoute`;
        await hbscan.delete(URL, {
            headers: { Authorization: Auth.guid },
            params: { routeId },
        });
    };

    PutRoute = async (route: IRouteUpdate) => {
        const URL = `/api/hbscan/Route/PutRoute`;
        return await hbscan.put(URL, JSON.stringify(route), {
            headers: { Authorization: Auth.guid },
        });
    };

    async GetRoute(routeId: number) {
        const URI = "/api/hbscan/Route/GetRoute";
        return (
            (
                await hbscan.get<IRoute>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { routeId },
                })
            ).data || null
        );
    }

    async GetRoutesByCompany() {
        const URI = "/api/hbscan/route/GetRoutesByCompanyId";
        return (
            (
                await hbscan.get<IRoute[]>(URI, {
                    headers: { Authorization: Auth.guid },
                })
            ).data || []
        );
    }

    async GetLocalRoutesByBuildingId(buildingId: number) {
        const URI = "/api/hbscan/route/GetLocalRoutesByBuildingId";
        return (
            (
                await hbscan.get<IRoute[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { buildingId },
                })
            ).data || []
        );
    }

    async GetRoutesByBuildingId(buildingId: number) {
        const URI = "/api/hbscan/route/GetRoutesByBuildingId";
        return (
            (
                await hbscan.get<IRoute[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { buildingId },
                })
            ).data || []
        );
    }

    async GetLocalRoutesByPropertyGroupId(propertyGroupId: number) {
        const URI = "/api/hbscan/route/GetLocalRoutesByPropertyGroupId";
        return (
            (
                await hbscan.get<IRoute[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { propertyGroupId },
                })
            ).data || []
        );
    }

    async GetRoutesByLocalId(localId: number) {
        const URI = "/api/hbscan/route/GetRoutesByLocalId";
        return (
            (
                await hbscan.get<IRoute[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { localId },
                })
            ).data || []
        );
    }
}

const routeService = new RouteService();

export default routeService;
